class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/overflow-settings`;
    }
    /**
     * Returns overflow settings for a call queue specified in path.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{callQueueId}/overflow-settings
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: CallQueueToCallQueue
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates overflow settings for a call queue specified in path.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{callQueueId}/overflow-settings
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: CallQueueToCallQueue
     */
    async put(callQueueOverflowSettingsRequestResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callQueueOverflowSettingsRequestResource, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
